import {
  GET_DATA_SOURCES,
  GET_DATA_SOURCES_FAILED,
  GET_DATA_SOURCES_SUCCEEDED,
  CONNECT_DATA_SOURCE,
  CONNECT_DATA_SOURCE_FAILED,
  CONNECT_DATA_SOURCE_SUCCEEDED,
  GET_EMAIL_PROVIDERS,
  GET_EMAIL_PROVIDERS_FAILED,
  GET_EMAIL_PROVIDERS_SUCCEEDED,
  DISCONNECT_DATA_SOURCE,
  DISCONNECT_DATA_SOURCE_FAILED,
  DISCONNECT_DATA_SOURCE_SUCCEEDED,
  GET_PLAID_CONNECTIONS,
  GET_PLAID_CONNECTIONS_FAILED,
  GET_PLAID_CONNECTIONS_SUCCEEDED,
  GET_WORKATO_CONNECTIONS,
  GET_WORKATO_CONNECTIONS_FAILED,
  GET_WORKATO_CONNECTIONS_SUCCEEDED,
} from 'Redux/Types/DataSourceTypes'

const INITIAL_STATE = {
  sources: [],
  connected: false,
  connecting: false,
  emailProviders: [],
  fetchingProviders: false,
  fetchingDataSources: false,
  dataSourcesFetched: false,
  fetchingPlaidConnections: false,
  fetchingWorkatoConnections: false,
  plaidConnections: [],
  workatoConnections: [],
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_DATA_SOURCES:
      return {
        ...state,
        fetchingDataSources: true,
        dataSourcesFetched: false,
      }
    case GET_DATA_SOURCES_FAILED:
      return {
        ...state,
        fetchingDataSources: false,
        dataSourcesFetched: false,
      }
    case GET_DATA_SOURCES_SUCCEEDED:
      return {
        ...state,
        sources: payload,
        fetchingDataSources: false,
        dataSourcesFetched: true,
      }

    case GET_EMAIL_PROVIDERS:
      return {
        ...state,
        fetchingProviders: true,
      }
    case GET_EMAIL_PROVIDERS_FAILED:
      return {
        ...state,
        fetchingProviders: false,
      }
    case GET_EMAIL_PROVIDERS_SUCCEEDED:
      return {
        ...state,
        fetchingProviders: false,
        emailProviders: payload,
      }
    case GET_PLAID_CONNECTIONS:
      return {
        ...state,
        fetchingPlaidConnections: true,
      }
    case GET_PLAID_CONNECTIONS_FAILED:
      return {
        ...state,
        fetchingPlaidConnections: false,
      }
    case GET_PLAID_CONNECTIONS_SUCCEEDED:
      return {
        ...state,
        fetchingPlaidConnections: false,
        plaidConnections: payload,
      }
    case GET_WORKATO_CONNECTIONS:
      return {
        ...state,
        fetchingWorkatoConnections: true,
      }
    case GET_WORKATO_CONNECTIONS_FAILED:
      return {
        ...state,
        fetchingWorkatoConnections: false,
      }
    case GET_WORKATO_CONNECTIONS_SUCCEEDED:
      return {
        ...state,
        fetchingWorkatoConnections: false,
        workatoConnections: payload,
      }
    case CONNECT_DATA_SOURCE:
      return {
        ...state,
        connecting: true,
        connected: false,
        latestConnection: {},
      }
    case CONNECT_DATA_SOURCE_FAILED:
      return {
        ...state,
        connected: false,
        connecting: false,
        error: payload.error,
        latestConnection: {},
      }
    case CONNECT_DATA_SOURCE_SUCCEEDED:
      return {
        ...state,
        connected: true,
        connecting: false,
        latestConnection: payload,
      }

    case DISCONNECT_DATA_SOURCE:
      return {
        ...state,
        loading: true,
        sources: state.sources.map((source) => {
          if (source.name === payload.name) {
            return { ...source, disconnecting: true, disconnected: false }
          }
          return source
        }),
      }
    case DISCONNECT_DATA_SOURCE_FAILED: {
      const { item } = payload
      return {
        ...state,
        loading: false,
        sources: state.sources.map((source) => {
          if (source.name === item.name) {
            return { ...source, disconnecting: false, disconnected: false }
          }
          return source
        }),
      }
    }
    case DISCONNECT_DATA_SOURCE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        sources: state.sources.map((source) => {
          if (source.name === payload.name) {
            return { ...source, disconnecting: false, disconnected: true, connectedEmail: null }
          }
          return source
        }),
      }

    default:
      return state
  }
}
